import PropTypes from 'prop-types';
import { useCallback } from 'react';
import Helmet from 'react-helmet';
import { useParams } from 'react-router-dom';

import { DefaultSheet } from 'twyne-new.ui'

import { useAppAlert } from '@Components/AppAlert';
import history from 'utils/history';

import Form from '../components/Form';
import { UserProvider, useUserStore } from '../store';

const propTypes = {
  match: PropTypes.object,
}

const UserForm = () => {
  const { id } = useParams()
  const { collection: { item, useLoad, useSubmit } } = useUserStore()
  const { handleSuccess, handleError } = useAppAlert()

  useLoad(id)

  const handleSubmit = useSubmit()

  const handleCloseSidebar = useCallback(() => {
    history.push('/settings/users')
  }, []);

  const handleSubmitAndClose = useCallback(async payload => {
    try {
      await handleSubmit(payload)
      handleCloseSidebar()
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `User ${message}.`)
    } catch {
      handleError('Error', 'User was not saved.')
    }
  }, [handleSubmit, handleCloseSidebar, handleSuccess, handleError])

  if (!item) {
    return null
  }

  return <>
    <DefaultSheet
      wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleCloseSidebar() }}
      title={item.id ? 'Edit User' : 'Add User'}
    >
      <Helmet title="User" />
      <Form data={item} handleSubmit={handleSubmitAndClose} />
    </DefaultSheet>
  </>
}

UserForm.propTypes = propTypes

export default function UserFormLayout() {
  return <UserProvider>
    <UserForm />
  </UserProvider>
}

